module.exports = __webpack_public_path__ + "static/media/ico-unlocked.c2948ee8.svg";